<template>
  <div class="image-item-content">
    <img
      :src="imageUrl"
      class="img-item"
      :style="{
        borderTopLeftRadius: topRadius ? topRadius : '',
        borderTopRightRadius: topRadius ? topRadius : '',
        borderBottomLeftRadius: bottomRadius ? bottomRadius : '',
        borderBottomRightRadius: bottomRadius ? bottomRadius : '',
        background: background ? background : '',
        objectFit: realMode,
      }"
      alt
    />
    <!-- borderRadius:radius?radius:'',  -->
  </div>
</template>

<script>
export default {
  name: '',
  props: {
    thumbnail: {
      type: Boolean,
      default: false,
    },
    bg: {
      type: String,
      default: '#fff',
    },
    url: {
      type: String,
    },
    mode: {
      type: String,
      default: 'global',
    },
    defaultUrl: {
      type: String,
      default: '',
    },
    w: {
      type: Number,
    },
    h: {
      type: Number,
    },
    // radius: {
    //   type: String,
    //   default: ""
    // },
    // p: {
    //   type: String,
    //   default: ''
    // },
    topRadius: {
      type: String,
    },
    bottomRadius: {
      type: String,
    },
    showLongPressMenu: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      background: null,
      imageUrl: null,
    };
  },
  watch: {
    url: {
      handler(val, oldVal) {
        this.setImageUrl(val);
      },
      immediate: true,
    },
    mode: {
      handler(val, oldVal) {
        this.setMode(val);
      },
      immediate: true,
    },
  },
  methods: {
    setImageUrl() {
      this.setMode();
      if (this.url) {
        this.hasInitUrl = true;
        if (this.hasInitUrl && this.hasInitMode) {
          this.createUrl();
        }
      }
    },
    getSuffixImageUrl(url, suffix, defaultUrl) {
      suffix = suffix || '';
      if (!url) {
        return defaultUrl || 'https://www.zai-art.com/appwrapper_dist/appDefaultImage/empty.png';
      }
      return /(http)|(https)|(\/\/)/gi.test(url)
        ? url.replace(/(^http:)|(^\/\/)/gi, 'https:') + suffix
        : 'https://img.zai-art.com/' + url + suffix;
    },

    getSuffix(mode) {
      let suffix = null;
      // let screenW = app.systemInfo
      //   ? app.systemInfo.windowWidth * app.systemInfo.pixelRatio
      //   : 750
      // let ratio = screenW / 750
      let w = this.w ? parseInt(this.w) : '';
      let h = this.h ? parseInt(this.h) : '';
      if (mode == 'contain') {
        if (this.thumbnail) {
          suffix = `?imageMogr2/thumbnail/!${w || ''}x${h || ''}`;
        } else {
          suffix = `?imageView2/2${w ? '/w/' + w * 2 : ''}${h ? '/h/' + h * 2 : h * 2}`;
        }
      } else if (this.thumbnail) {
        suffix = `?imageMogr2/thumbnail/!${w || ''}x${h || ''}`;
      } else {
        suffix = `?imageView2/1${w ? '/w/' + w * 2 : ''}${h ? '/h/' + h * 2 : h * 2}`;
      }
      return suffix;
    },

    setMode() {
      let mode = null;
      if (this.mode == 'global') {
        mode = 'aspectFill'; // 暂时只支持这一个mode
        if (this.$store.getters.global && this.$store.getters.global.imageMode) {
          mode = this.$store.getters.global.imageMode;
        } else {
          mode = 'aspectFill';
        }
      } else {
        mode = this.mode;
      }
      if (!mode) mode = 'aspectFit';
      this.realMode = mode == 'aspectFit' ? 'contain' : 'cover';

      this.hasInitMode = true;
    },
    createUrl() {
      let suffix = this.getSuffix(this.realMode);
      let url = this.getSuffixImageUrl(this.url, suffix, this.defaultUrl);
      // let color = this.bg || app.globalData.imageColor;
      let color = this.bg;
      this.imageUrl = url;
      this.background = color;
    },
    onLoad() {
      this.background = this.bg;
    },
    onError() {},
  },
};
</script>

<style lang="less" scoped>
.image-item-content {
  margin: 0;
  height: 100%;
  width: 100%;
  position: relative;
  line-height: 0;
  .img-item {
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
  img {
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
}
</style>
